import { useGetExistingStatusChecksByMonitorUrl } from 'components/status-checks/hooks/use-get-existing-status-checks-by-monitor-url'

/**
 * Convenience hook which returns the id field of the first matching status check
 * based on the current status check form's `monitorUrl` field value. Does not return
 * a value if the only matching status check happens to be the one being edited.
 */
export function useGetFirstMatchingStatusCheckIdByMonitorUrl() {
  const statusChecksWithDuplicateMonitorUrls =
    useGetExistingStatusChecksByMonitorUrl() ?? []

  return statusChecksWithDuplicateMonitorUrls[0]?.id
}
